import { useQuery } from '@tanstack/react-query';
import { AmcLambdaFetch, awaitJSON } from '@src/utils/fetch-utils';
import { AmcReport } from '../amc-insights-types';

const fetchAmcReports = async (amcInstanceId: string): Promise<AmcReport[]> => {
  const response = await AmcLambdaFetch('/getAmcReports', { params: { amcInstanceId } });
  return awaitJSON<AmcReport[]>(response);
};

export const useAmcReports = (amcInstanceId?: string): ReturnType<typeof useQuery<AmcReport[]>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['amcReports', amcInstanceId],
    // `enabled` guarantees amcInstanceId is defined before queryFn runs.
    queryFn: () => fetchAmcReports(amcInstanceId!),
    enabled: Boolean(amcInstanceId)
  });
